import Vue from 'vue'
import Router from 'vue-router'
import Login from './views/Login.vue'
import MyPage from './views/MyPage.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: '로그인',
      component: Login
    },
    {
      path: '/logout/:id',
      name: '로그아웃',
      component: Login
    },
    {
      path: '/myPage',
      name: '마이페이지',
      component: MyPage
    },
    {
      path: '/crop',
      name: '이미지크롭',
      component: () => import('./views/ImageCrop.vue')
    },
    {
      path: '/main',
      name: '메인뷰(탑메뉴)',
      component: () => import('./views/Main.vue'),
      children: [
        {
          path: 'division',
          name: '부서관리',
          component: () => import('./views/base-data/Division.vue')
        },
        {
          path: 'person',
          name: '직원관리',
          component: () => import('./views/base-data/Employee.vue')
        },
        {
          path: 'location',
          name: '장소관리',
          component: () => import('./views/base-data/Location.vue')
        },
        {
          path: 'company',
          name: '거래처관리',
          component: () => import('./views/base-data/Company.vue')
        },
        {
          path: 'carType',
          name: '완성품구룹관리(예:차종)',
          component: () => import('./views/base-data/CarType.vue')
        },
        {
          path: 'productionItems',
          name: '품목관리',
          component: () => import('./views/base-data/ProductTab.vue')
        },
        {
          path: 'operatingDays',
          name: '조업관리',
          component: () => import('./views/base-data/OperatingDays.vue')
        },
        {
          path: 'scrapCost',
          name: '스크랩/코일가 관리',
          component: () => import('./views/base-data/PressScrapCost.vue')
        },
        {
          path: 'sellingPrice',
          name: '판매가 관리',
          component: () => import('./views/base-data/SellingPrice.vue')
        },
        {
          path: 'salesClosed',
          name: '월매출마감관리',
          component: () => import('./views/base-data/SalesClosed.vue')
        },
        {
          path: 'salesStatus',
          name: '부품매출현황',
          component: () => import('./views/base-data/SalesStatus.vue')
        },
        {
          path: 'productionReceiptCheck',
          name: '출하비교',
          component: () => import('./views/base-data/Check.vue')
        },
        {
          path: 'bomReg',
          name: 'BOM관리',
          component: () => import('./views/bom/BomTab.vue')
        },
        {
          path: 'bomDeployTab',
          name: 'BOM조회',
          component: () => import('./views/bom/BomTreeDeployTab.vue')
        },
        {
          path: 'productMaterialCost',
          name: '완제품재료비',
          component: () => import('./views/bom/ProductMaterialCostTab.vue')
        },
        {
          path: 'productSalesPrice',
          name: '완제품판매가',
          component: () => import('./views/bom/ProductSalesPrice.vue')
        },
        {
          path: 'productDrawing',
          name: '도면관리',
          component: () => import('./views/base-data/ProductDrawing.vue')
        },
        {
          path: 'pressDieInfo',
          name: '금형관리',
          component: () => import('./views/base-data/PressDieInfo.vue')
        },
        {
          path: 'machineTab',
          name: '설비관리',
          component: () => import('./views/base-data/MachineTab.vue')
        },
        // 생산관리
        {
          path: 'monthPlan',
          name: '월생산계획',
          component: () => import('./views/ProductionMag/MonthPlanTab.vue')
        },
        {
          path: 'weekPlan',
          name: '주간생산계획',
          component: () => import('./views/ProductionMag/WeekPlanTab.vue')
        },
        {
          path: 'workOrder',
          name: '생산지시',
          component: () => import('./views/ProductionMag/WorkOrder.vue')
        },
        {
          path: 'workOutput',
          name: '생산실적',
          component: () => import('./views/ProductionMag/WorkOutput.vue')
        },
        {
          path: 'productionDailyResultRow',
          name: '일생산실적',
          component: () =>
            import('./views/ProductionMag/DailyProductionResultRowTab.vue')
        },
        {
          path: 'productionMonthResultRow',
          name: '월생산실적',
          component: () =>
            import('./views/ProductionMag/MonthProductionResultRowTab.vue')
        },
        {
          path: 'productionYearResultRow',
          name: '연생산실적',
          component: () =>
            import('./views/ProductionMag/YearProductionResultRowTab.vue')
        },
        {
          path: 'productionMonthResult',
          name: '월생산실적(피봇)',
          component: () =>
            import('./views/ProductionMag/MonthProductionResultTab.vue')
        },
        {
          path: 'productionYearResult',
          name: '연생산실적(피봇)',
          component: () =>
            import('./views/ProductionMag/YearProductionResultTab.vue')
        },
        {
          path: 'productionDailyPlan',
          name: '생산계획상세',
          component: () =>
            import('./views/ProductionMag/ProductionDailyPlanTab.vue')
        },
        // 구매관리
        {
          path: 'pressPurchasePrice',
          name: '프레스재료비정보',
          component: () => import('./views/PurchaseMag/PressPurchasePrice.vue')
        },
        {
          path: 'rawMaterialsOutput',
          name: '원자재사급내역',
          component: () => import('./views/PurchaseMag/RawMaterialsOutput.vue')
        },
        {
          path: 'coilInputMag',
          name: '코일INPUT',
          component: () => import('./views/PurchaseMag/CoilInputReceipt.vue')
        },
        {
          path: 'coilChangeMag',
          name: '코일용도변경',
          component: () => import('./views/PurchaseMag/CoilChangeReceipt.vue')
        },
        {
          path: 'rawMaterialsClosed',
          name: ' 원자재 매입 정산',
          component: () => import('./views/PurchaseMag/RawMaterialsClosed.vue')
        },
        {
          path: 'coilOutputMag',
          name: '원자재 사급관리',
          component: () =>
            import('./views/PurchaseMag/RawMaterialsDetailOutput.vue')
        },
        {
          path: 'coilPlanAndDailyInput',
          name: '원자재 계획/입고',
          component: () =>
            import('./views/PurchaseMag/CoilPlanAndDailyInputTab.vue')
        },
        {
          path: 'rawMaterialsInOutSummary',
          name: '구매/사급 내역총괄',
          component: () =>
            import('./views/PurchaseMag/RawMaterialsInOutSummary.vue')
        },
        {
          path: 'monthPurchaseList',
          name: '월외주품입고내역',
          component: () =>
            import('./views/PurchaseMag/MonthPressPurchaseList.vue')
        },
        {
          path: 'monthHardwareList',
          name: '월하드웨어입고내역',
          component: () => import('./views/PurchaseMag/MonthHardwareList.vue')
        },
        {
          path: 'outsourcedGoodsInputPivot',
          name: '외주품구매(피봇)',
          component: () =>
            import('./views/PurchaseMag/OutsourcedGoodsPivotTab.vue')
        },
        {
          path: 'purchasePlanInputTab',
          name: '구매품 계획대입고',
          component: () =>
            import('./views/PurchaseMag/PurchasePlanInputTab.vue')
        },
        {
          path: 'purchaseInputPivot',
          name: '자재구매(피봇)',
          component: () => import('./views/PurchaseMag/PurchasePivotTab.vue')
        },
        {
          path: 'rawMaterialsInputPivot',
          name: '원자재구매내역',
          component: () => import('./views/PurchaseMag/RawMaterialPivotTab.vue')
        },
        {
          path: 'purchaseClosed',
          name: '외주하드웨어정산자료',
          component: () => import('./views/PurchaseMag/PurchaseClosed.vue')
        },
        {
          path: 'productReceiptPivot',
          name: '제품출하내역',
          component: () =>
            import('./views/PurchaseMag/ProductReceiptPivotTab.vue')
        },
        {
          path: '차종별사양등록',
          name: '차종별사양등록',
          component: () => import('./views/sales/regCarOptionTab.vue')
        },
        {
          path: 'doKubSummary',
          name: '도급생산현황',
          component: () => import('./views/PurchaseMag/DoKubTab.vue')
        },
        {
          path: 'pressDieMagTab',
          name: '금형타수관리',
          component: () =>
            import('./views/PurchaseMag/PressDiePressingCountTab.vue')
        },
        // 재고관리
        {
          path: 'weekMrp',
          name: '주간MRP',
          component: () => import('./views/InventoryMag/WeekMrpTab.vue')
        },
        {
          path: 'inventoryReceipt',
          name: '자재수불',
          component: () =>
            import('./views/InventoryMag/InventoryReceiptTab.vue')
        },
        {
          path: 'rawMaterialsReceipt',
          name: '원자재수불',
          component: () =>
            import('./views/InventoryMag/RawMaterialsReceipt.vue')
        },
        {
          path: 'productionReceipt',
          name: '제품수불',
          component: () => import('./views/InventoryMag/ProductionReceipt.vue')
        },
        {
          path: 'badGoodsReceipt',
          name: '불량수불',
          component: () => import('./views/InventoryMag/BadGoodsReceipt.vue')
        },
        {
          path: 'qrCodeSerialNo',
          name: '입고QR코드',
          component: () => import('./views/InventoryMag/QrCodeSerialNo.vue')
        },
        {
          path: 'inventoryCount',
          name: '실사관리',
          component: () => import('./views/InventoryMag/InventoryCount.vue')
        },
        {
          path: 'currentAdjustStock',
          name: '재고조정',
          component: () =>
            import(
              './views/InventoryMag/CurrentStockAdjust/CurrentStockAdjustTab.vue'
            )
        },
        {
          path: 'currentStock',
          name: '재고현황',
          component: () =>
            import('./views/InventoryMag/CurrentStock/CurrentStockTab.vue')
        },
        // 설비가동관리
        {
          path: 'lineMonitoring',
          name: '라인가동현황',
          component: () => import('./views/MachinePm/LineMonitoring.vue')
        },
        {
          path: 'machineRepair',
          name: '설비수리현황',
          component: () => import('./views/MachinePm/MachineRepairTab.vue')
        },
        {
          path: 'lineInterruption',
          name: '라인중단등록',
          component: () => import('./views/MachinePm/LineStop.vue')
        },
        // 종합현황
        {
          path: 'dashBoard',
          name: '종합지표',
          component: () => import('./views/DashBoard/Dashboard.vue')
        },
        {
          path: 'productChart',
          name: '연생산현황',
          component: () => import('./views/DashBoard/ProduceChart.vue')
        },
        {
          path: 'lineStopChart',
          name: '연중단현황',
          component: () => import('./views/DashBoard/LineStopChart.vue')
        },
        {
          path: 'badProductCharts',
          name: '연불량현황',
          component: () => import('./views/DashBoard/BadProductChart.vue')
        },
        {
          path: 'purchaseChart',
          name: '연구매현황',
          component: () => import('./views/DashBoard/PurchaseChart.vue')
        },
        {
          path: 'monthPlanVsResult',
          name: '월계획대비실적',
          component: () => import('./views/DashBoard/MonthPlanVsResult.vue')
        },
        // 검사
        {
          path: 'hardwareInspection',
          name: '하드웨어검사',
          component: () =>
            import('./views/Inspection/HardwareInspectionTab.vue')
        },
        {
          path: 'pressInspection',
          name: '외주품검사',
          component: () => import('./views/Inspection/PressInspectionTab.vue')
        },
        // SYSTEM MENU
        {
          path: 'baseCode',
          name: '공통코드',
          component: () => import('./views/system/BaseCode.vue')
        },
        {
          path: 'menuPermission',
          name: '메뉴권한',
          component: () => import('./views/system/MenuPermission.vue')
        }
      ]
    }
  ]
})
